// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart__HUloz"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewayTOAUplinkPie/styles.scss
// module id = 2272
// module chunks = 1